<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          アンケート一覧
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
            </template>
            <div v-if="this.$root.adminFlg == false">アンケート(登録したもの・共同編集者となっているもの)について</div>
            <div v-if="this.$root.adminFlg == true">アンケート(全ユーザーの登録したもの)について</div>
            <div>公開状態の変更・編集・削除・Excel出力ができます。</div>
          </v-tooltip>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 検索用のテキスト入力 -->
        <v-autocomplete
          v-model="groupFilterValue"
          label="グループ指定"
          placeholder="グループ指定"
          :items="groupNames"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 検索用のテキスト入力 -->
        <v-autocomplete
          v-model="postUsersFilterValue"
          label="作成者指定"
          placeholder="作成者指定"
          :items="postUsers"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 検索用の年度入力 -->
        <v-autocomplete
          v-model="selectNendo"
          label="年度指定"
          placeholder="年度指定"
          :items="nendoList"
          @change="reload"
          outlined
          dense
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <v-switch 
          v-model="viewFavoriteOnly"
          dense
          class="mt-1"
          label="お気に入りのみ"
          hide-details="auto"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="surveys"
          :items-per-page.sync="perPage"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          :loading="isSurveysLoding" loading-text="読込中"
        >
          <!-- ラベル：更新日と投稿者 -->
          <template #[`header.postUser`]="{}"> 
            <v-row no-gutters><v-col cols="12" justify="center">更新日時</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">作成者</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">共同編集</v-col></v-row>
          </template>
          <!-- 更新日と投稿者 -->
          <template #[`item.postUser`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.editDate }}</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.postUser }}</v-col></v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                <span v-if="item.editAllowIds.length > 1 && item.editAllowFlg == false">設定有</span>
                <span v-if="item.editAllowIds.length > 1 && item.editAllowFlg == true">権限有</span>
              </v-col>
            </v-row>
          </template>
          <!-- ラベル：タイトルとグループ名(代表者) -->
          <template #[`header.groupName`]="{}"> 
            <v-row no-gutters><v-col cols="12" justify="center">タイトル</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">グループ名(代表者)</v-col></v-row>
          </template>
          <!-- タイトルとグループ名(代表者) -->
          <template #[`item.groupName`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.title }}</v-col></v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                {{ item.groupName }}<span v-if="item.ownerUser">({{ item.ownerUser }})</span>
              </v-col>
            </v-row>
          </template>
          <template #[`item.target`]="{ item }">
            <v-icon x-large v-if="item.studentFlg">$student</v-icon>
            <v-icon x-large v-if="item.parentFlg">$parent</v-icon>
            <v-icon x-large v-if="item.teacherFlg">$teacher</v-icon>
            <div v-if="item.targetSelectFlg">【限定】</div>
          </template>
          <!-- お気に入り -->
          <template #[`item.favoriteFlg`]="{ item }">
            <v-tooltip top v-if="item.favoriteFlg">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small outlined v-bind="attrs" v-on="on" @click="changeFavoriteSurveys(item)"><v-icon color="orange">mdi-star</v-icon></v-btn>
              </template>
              <span>お気に入りを解除する</span>
            </v-tooltip>
            <v-tooltip top v-if="!item.favoriteFlg">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small outlined v-bind="attrs" v-on="on" @click="changeFavoriteSurveys(item)"><v-icon>mdi-star-outline</v-icon></v-btn>
              </template>
              <span>お気に入りに追加する</span>
            </v-tooltip>
          </template>
          <!-- 編集と通知 -->
          <template #[`item.editAndMail`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :loading="item.isCountLoading" :disabled="item.isCountLoading" icon small outlined color="green" v-bind="attrs" v-on="on" @click="onClickEditItem(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>アンケートを編集する</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" justify="center" style="white-space : nowrap;">
                <v-tooltip bottom v-if="tounendo == selectNendo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="openMailModal(item)">
                      <v-icon color="green">mdi-email-plus-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>通知予約を登録する</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="onClickMailLog(item)">
                      <v-icon color="green">mdi-email-search-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>通知状況を確認する</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
          <!-- 公開期間 -->
          <template #[`item.publishDate`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center" style="white-space : nowrap;">{{ item.openDate }}～</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center" style="white-space : nowrap;">{{ item.limitDate }}
              <v-tooltip top v-if="item.limitBlockFlg">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-lock-outline</v-icon>
                </template>
                <span>期限で回答を締切ります</span>
              </v-tooltip>
              <v-tooltip top v-if="!item.limitBlockFlg">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-lock-open-variant-outline</v-icon>
                </template>
                <span>期限で回答を締切りません</span>
              </v-tooltip>
            </v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center" style="white-space : nowrap;">{{ item.closeDate }}</v-col></v-row>
          </template>
          <!-- 公開状態 -->
          <template #[`item.isOpen`]="{ item }">
            <v-btn color="accent" class="black--text" v-if="item.publishFlg && tounendo == selectNendo && !item.beforeOpeningFlg" @click="onClickChangeOpenStatus(item)">公開中</v-btn>
            <v-btn color="white" class="black--text" v-if="item.publishFlg && tounendo == selectNendo && item.beforeOpeningFlg" @click="onClickChangeOpenStatus(item)">公開前</v-btn>
            <v-btn color="grey" class="black--text" v-if="!item.publishFlg && tounendo == selectNendo" @click="onClickChangeOpenStatus(item)">停止中</v-btn>
            <v-btn color="grey" class="black--text" v-if="tounendo != selectNendo" :disable="true">停止中</v-btn>
          </template>
          <!-- ユーザー閲覧数 -->
          <template #[`item.count`]="{ item }">
            <v-tooltip top v-if="!item.anonymousFlg">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :loading="item.isCountLoading" v-bind="attrs" v-on="on" @click="onClickAnswerStatusSurvey(item)">{{ item.count }}</v-btn>
              </template>
              <span>回答状況を確認する</span>
            </v-tooltip>
            <v-tooltip top v-if="item.anonymousFlg">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :loading="item.isCountLoading" v-bind="attrs" v-on="on" :disable="true">{{ item.count }}</v-btn>
              </template>
              <span>匿名時はExcelにて回答状況を確認してください</span>
            </v-tooltip>
          </template>
          <!-- Excel出力 -->
          <template #[`item.action`]="{ item }">
            <v-row no-gutters>
              <v-col cols="6" justify="center">
                <v-tooltip top v-if="item.canChartViewFlg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="onClickChartView(item)" ><v-icon color="green">mdi-chart-arc</v-icon></v-btn>
                  </template>
                  <span>集計結果をグラフで確認する</span>
                </v-tooltip>
              </v-col>
              <v-col cols="6" justify="center">
                <v-tooltip bottom v-if="item.exportAllowFlg == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="onClickExport(item)"><v-icon color="green">mdi-file-excel</v-icon></v-btn>
                  </template>
                  <span>Excel出力する</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" :disable="true">
                      <v-icon color="grey">mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>作成者または共同編集者または管理者のみ出力可能です</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="6" justify="center">
                <v-tooltip bottom v-if="tounendo == selectNendo && item.deleteAllowFlg == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="onClickDeleteItem(item)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>アンケートを削除する</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" :disable="true">
                      <v-icon color="grey">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="tounendo == selectNendo">作成者か管理者のみ削除可能です</span>
                  <span v-else>過年度のデータのためロックされています</span>
                </v-tooltip>
              </v-col>
              <v-col cols="6" justify="center">
                <v-tooltip left v-if="tounendo == selectNendo && item.deleteAllowFlg == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" @click="onClickEditAllowDialog(item)">
                      <v-icon color="green">mdi-account-multiple-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>共同編集者を変更する</span>
                </v-tooltip>
                <v-tooltip left v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined small v-bind="attrs" v-on="on" :disable="true">
                      <v-icon color="grey">mdi-account-multiple-plus</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="tounendo == selectNendo">共同編集者の変更は作成者か管理者のみ可能です</span>
                  <span v-else>過年度のデータのためロックされています</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

    <!-- メール送信モーダル -->
    <v-dialog
      v-model="mailDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="ml-5">アンケートを通知する</v-card-title>
        <v-list-item-subtitle class="ml-3" style="font-size:.835rem;">非公開の場合は公開になり次第通知されます</v-list-item-subtitle>
        <v-card-text>
          <v-radio-group v-model="mailType" :mansdatory="false">
            <v-radio label="アンケートの登録を通知する" value="A-0"></v-radio>
            <v-radio label="アンケートの修正を通知する" value="A-1"></v-radio>
            <v-radio label="未回答者に対して再通知する" value="A-2"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="grey" @click="mailDialog = false">
                閉じる
              </v-btn>
            </v-col>
            <v-col cols="3" justify="center"></v-col>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="accent" @click="sendMailSurvey()">
                送信予約
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 入力状況出力モーダル -->
    <v-dialog
      v-model="exportDialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="pl-5" style="font-size:1.012rem;">アンケートの情報を出力する</v-card-title>
        <v-card-subtitle class="pl-5">※対象グループが全校ですと、最大で20秒程度お待ちいただく必要があります。</v-card-subtitle>
        <v-card-text>
          <v-radio-group v-model="exportType" :mansdatory="false" :disabled="isExportingFlg">
            <v-radio label="アンケートの入力状況を出力する" value="0"></v-radio>
            <v-radio label="アンケートの結果を出力する" value="1"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="grey" :disabled="isExportingFlg" @click="exportDialog = false">
                閉じる
              </v-btn>
            </v-col>
            <v-col cols="3" justify="center"></v-col>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="accent" :disabled="isExportingFlg" :loading="isExportingFlg" @click="exportExcelSurveyStatus()">
                出力
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 通知履歴モーダル -->
    <v-dialog
      v-model="mailLogDialog"
      max-width="1200"
    >
      <v-card>
        <v-card-title class="pl-5" style="font-size:1.012rem;">通知履歴</v-card-title>
        <v-card-subtitle class="pl-5">※完了まで数分かかる場合があります</v-card-subtitle>
        <v-card-subtitle class="pl-5">※通知可能なメールもしくはスマホアプリを１件としてカウントしています</v-card-subtitle>
        <v-card-text>
          <v-data-table
            :headers="mailLogHeader"
            :items="mailLogList"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
          >
          <template #[`item.cancel`]="{ item }">
            <v-btn color="green" small class="white--text" v-if="item.status == '0' || item.status == '1'" @click="cancelNotification(item)">キャンセル</v-btn>
          </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 共同編集者変更モーダル -->
    <v-dialog
      v-model="editAllowDialog"
      max-width="700"
      min-height="120"
      persistent
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="editAllowDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              共同編集者を変更する
            </v-col>
            <v-col cols="2" justify="center">
              <v-btn color="accent" class="black--text" @click="changeEditAllowIds()" width="90%">
                変更
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text class="d-flex justify-center flex-column">
          <v-row dense>
            <v-col dense cols="12" justify="center">
              <v-autocomplete
                v-model="editAllowIds"
                label="共同編集者"
                placeholder="共同編集者"
                :items="teacherList"
                outlined
                dense
                multiple
                deletable-chips
                clearable
                small-chips
                hide-details="auto"
                background-color="white"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>
  
<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import { saveAsCommon } from '../../common';
import Enumerable from "linq";
export default {
  data() {
    return {
      postUsersFilterValue: "",
      groupFilterValue: "",
      tounendo: "",
      selectNendo: "",
      nendoList : [],
      viewFavoriteOnly: false,
      postUsers : [],
      groupNames : [],
      headers: [
        { text: "更新日時/作成者/共同編集", value: "postUser", width: "180", filter: this.postUserFilter },
        { text: "タイトル/グループ名", value: "groupName", width: "35%", filter: this.groupNameFilter  },
        { text: "対象", value: "target" },
        { text: "お気に入り", value: "favoriteFlg", width: "5%", filter: this.favoriteFilter },
        { text: "匿名", value: "anonymousState", width: "5%" },
        { text: "編集/通知", value: "editAndMail", width: "100" },
        { text: "公開開始/締切/終了", value: "publishDate", width: "210" },
        { text: "公開状態", value: "isOpen", width: "120" },
        { text: "全体：回答済：未回答", value: "count", width: "170" },
        { text: "操作", value: "action", width: "100" },
      ],
      surveys: [],
      isSurveysLoding: false,
      mailDialog: false,
      exportDialog: false,
      mailSurveyId: "",
      mailType: "1",
      exportSurveyId: "",
      exportType: "0",
      mailLogDialog: false,
      mailLogHeader: [
        { text: "登録日時", value: "insDate"},
        { text: "通知区分", value: "typeNm"},
        { text: "通知設定者", value: "postUser"},
        { text: "状態", value: "statusNm"},
        { text: "全件数", value: "allCount"},
        { text: "通知済件数", value: "doneCount"},
        { text: "未通知件数", value: "notYetCount"},
        { text: "通知完了日時", value: "updDate"},
        { text: "キャンセル", value: "cancel"},
      ],
      mailLogList: [],
      perPage: 30,
      isExportingFlg: false,

      // 共同編集者変更用ダイアログ
      editAllowDialog: false,
      editAllowSurveyId: "",
      editAllowIds: [],
      teacherList:[],
      baseTeacherList:[],
    };
  },
  // 初期表示時データ読み込み
  async created() {
    this.perPage = this.$store.state.parPageSurveyList;
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
    await schoolAidHomeLogined({funcName: "commonGetNendo"}).then((ret) => {
      this.tounendo = ret.data.tounendo;
      this.selectNendo = ret.data.tounendo;
      this.nendoList = ret.data.list;
    });
    
    // 教員リストの取得
    await schoolAidHomeLogined({funcName: "commonGetTeachers", includeFlg: true}).then((ret) => {
      this.baseTeacherList = ret.data.teacherList;
    })
    await this.reload();
  },
  watch: {
    perPage: function(newVal) {
      this.$store.dispatch('setParPageSurveyList', newVal);
    },
  },
  methods: {
    // 投稿者名フィルタ
    postUserFilter(value) {
      if (!this.postUsersFilterValue) {
        return true;
      }
      return value.toString().includes(this.postUsersFilterValue);
    },
    // グループ名フィルタ
    groupNameFilter(value) {
      if (!this.groupFilterValue) {
        return true;
      }
      return value.toString().includes(this.groupFilterValue);
    },
    // お気に入りフィルタ
    favoriteFilter(value) {
      if (!this.viewFavoriteOnly) {
        return true;
      }
      return value;
    },
    async changeFavoriteSurveys(item)  {      
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      var data = {
        funcName: "changeFavoriteSurveys",
        surveyId: item.surveyId,
        favoriteFlg: item.favoriteFlg
      };
      await schoolAidHomeLogined(data);
      item.favoriteFlg = !item.favoriteFlg;
    },
    async reload() {
      var temp_postUsers = new Set();
      var temp_groupNames = new Set();
      this.surveys = [];
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isSurveysLoding = true;
      var param = {
        funcName:"loadSurveyList",
        nendo: this.selectNendo
      }
      await schoolAidHomeLogined(param).then((surveys) => {
        var ret = [];
        surveys.data.forEach((survey) => {
          temp_postUsers.add(survey.postUser);
          temp_groupNames.add(survey.groupName);
          var count = survey.allCount + "：" + survey.doneCount + "：" + survey.notYetCount;
          var row = {
            postDate: survey.postDate,
            postUser: survey.postUser,
            editDate: survey.editDate,
            groupName : survey.groupName,
            ownerUser : survey.ownerUser,
            studentFlg: survey.studentFlg,
            parentFlg: survey.parentFlg,
            teacherFlg: survey.teacherFlg,
            title : survey.title,
            openDate: survey.openDate,
            closeDate: survey.closeDate,
            limitDate: survey.limitDate,
            limitBlockFlg: survey.limitBlockFlg,
            publishFlg : survey.publishFlg,
            count : count,
            allCount : survey.allCount,
            surveyId : survey.surveyId,
            isCountLoading: survey.isCountLoading,
            mailAddressAuthFlg: survey.mailAddressAuthFlg,
            favoriteFlg: survey.favoriteFlg,
            beforeOpeningFlg: survey.beforeOpeningFlg,
            targetSelectFlg: survey.targetSelectFlg,
            canChartViewFlg: survey.canChartViewFlg,
            anonymousFlg: survey.anonymousFlg,
            anonymousState: (survey.anonymousFlg) ? "匿名" : "",
            createId: survey.createId,
            editAllowFlg: survey.editAllowFlg,
            editAllowIds: survey.editAllowIds,
            exportAllowFlg: survey.exportAllowFlg,
            deleteAllowFlg: survey.deleteAllowFlg,
          };

          ret.push(row);
        });
        this.surveys = ret;
        this.isSurveysLoding = false;
        this.postUsers = Array.from(temp_postUsers);
        this.groupNames = Array.from(temp_groupNames);
      });
    },

    // 公開状態変更
    async onClickChangeOpenStatus(item) {
      var result = confirm("公開状態を変更してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var param = {
        funcName: "changeOpenStatusSurvey",
        surveyId: item.surveyId,
        publishFlg: item.publishFlg,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param);
      // ローディング終了
      this.$root.loading = false;
      await this.reload();
    },

    // アンケート修正
    onClickEditItem(item) {
      this.$router.push({
        name: "SurveyEdit",
        params: {
          id: item.surveyId,
        }
      });
    },
    // 論理削除
    async onClickDeleteItem(item) {
      var result = confirm("削除してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var param = {
        funcName: "deleteSurvey",
        surveyId: item.surveyId,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param);
      // ローディング終了
      this.$root.loading = false;
      await this.reload();
    },
    // 通知送信モーダルを開く
    openMailModal(item) {
      this.mailSurveyId = item.surveyId;
      this.mailType = "A-1";
      this.mailDialog = true;
    },
    // 通知処理
    async sendMailSurvey() {
      var result = confirm("通知してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var param = {
        funcName: "sendMailSurvey",
        surveyId: this.mailSurveyId,
        mailType: this.mailType,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then(() => {
        alert("受け付けました");
      });
      // ローディング終了
      this.$root.loading = false;
      this.mailDialog = false;
    },
    // 回答状況一覧
    onClickAnswerStatusSurvey(item) {
      if(item.allCount > 200){
        var result = confirm("対象者が200名を超える場合はExcel出力を推奨しています。続行しますか？");
        if (!result) {
          return;
        }
      }

      this.$router.push({
        name: "AnswerStatusSurvey",
        params: {
          id: item.surveyId,
        }
      });
    },
    // 入力状況確認
    onClickExport(item) {
      this.exportSurveyId = item.surveyId;
      this.exportType = "0";
      this.exportDialog = true;
    },
    // エクセル出力処理
    async exportExcelSurveyStatus() {
      var result = confirm("出力してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.isExportingFlg = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var funcName = "";
      if(this.exportType == "0") {
        funcName = "exportExcelSurveyStatus";
      } else if(this.exportType == "1") {
        funcName = "exportExcelSurveyReport";
      }

      var param = {
        funcName: funcName,
        surveyId: this.exportSurveyId,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data.message){
          alert(ret.data.message);
        } else {
          saveAsCommon(ret.data.downloadUrl, ret.data.fileName);
          alert("ダウンロードを開始します。\nダウンロードフォルダをご確認ください。\n※ファイルを確認出来ない場合はポップアップがブロックされていないか\nご確認ください。");
        }
      });
      // ローディング終了
      this.isExportingFlg = false;
      this.exportDialog = false;
    },
    // アンケートグラフ表示
    onClickChartView(item) {
      this.$router.push({
        name: "SurveyChartView",
        params: {
          id: item.surveyId,
        }
      });
    },
    // 通知履歴確認
    async onClickMailLog(item) {
      var param = {
        funcName: "commonGetMailLog",
        id: item.surveyId,
        type: "A",
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        this.mailLogList = ret.data;
      });
      this.mailLogDialog = true;
    },
    // 通知キャンセル処理
    async cancelNotification(item) {
      var result = confirm("通知をキャンセルしてよろしいですか？");
      if (!result) {
        return;
      }

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var param = {
        funcName: "commonCancelNotification",
        queId: item.queId,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data != "success"){
          alert(ret.data);
        } else {
          alert("キャンセルしました");
        }
      });
      
      this.mailLogDialog = false;
    },
    // 共同編集変更ダイアログを開く
    onClickEditAllowDialog(item){
      this.editAllowSurveyId = item.surveyId;
      let editAllowIdsSet = new Set(item.editAllowIds);
      editAllowIdsSet.delete(item.createId);
      
      this.editAllowSurveyId = item.surveyId;
      this.editAllowIds = Array.from(editAllowIdsSet);
      this.teacherList = Enumerable.from(this.baseTeacherList).where(i => i.value != item.createId).toArray();
      this.editAllowDialog = true;
    },
    // 共同編集ID変更処理
    async changeEditAllowIds(){
      var result = confirm("共同編集者を変更しますか？");
      if (!result) {
        return;
      }

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var param = {
        funcName: "changeEditAllowIds",
        surveyId: this.editAllowSurveyId,
        editAllowIds: this.editAllowIds,
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data){
          for(var row1 of this.surveys){
            if(row1.surveyId == this.editAllowSurveyId){
              row1.editAllowIds = ret.data;
            }
          }
        } else {
          for(var row2 of this.surveys){
            if(row2.surveyId == this.editAllowSurveyId){
              row2.editAllowIds = [];
            }
          }
        }
        alert("変更しました。");
        this.editAllowDialog = false;
      });
    },
  },
};
</script>

<style scoped>
.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal-header {
  border-bottom: 1px solid #ddd;
}

</style>